export default __webpack_public_path__ + "static/media/about_2.2ed3d39e.jpg";